import { TagAlertHitWithMessageSchema } from "../../../api-client";
import { Alert, AlertDescription } from "../../../components/ui/alert";
import { Stack } from "../../../components/ui/stack";

import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

import * as React from "react";
import { useTimezone } from "../../../utils/hooks";
import { formatInTimeZone } from "date-fns-tz";

type TagAlertsVerboseListProps = {
  alertList: TagAlertHitWithMessageSchema[];
};

export const TagAlertsVerboseList = (
  props: TagAlertsVerboseListProps,
): React.ReactElement => {
  const [displayTz] = useTimezone();
  return (
    <Stack className="p-4" spacing={1}>
      {props.alertList.map((hit: TagAlertHitWithMessageSchema) => (
        <Alert variant={levelToAlertSev(hit.level)} key={`alert_${hit.title}`}>
          <AlertDescription>
            <div>
              <b>{hit.title}</b> (first happened at{" "}
              <b>
                {formatInTimeZone(
                  hit.firstOccurred,
                  displayTz,
                  "yyyy-MM-dd HH:mm:ss",
                )}
              </b>
              )
            </div>
            {hit.message && (
              // @ts-ignore
              <ReactMarkdown rehypePlugins={[rehypeRaw]}>
                {hit.message}
              </ReactMarkdown>
            )}
          </AlertDescription>
        </Alert>
      ))}
    </Stack>
  );
};
export const levelToAlertSev = (
  level: number | undefined,
): "default" | "destructive" | "info" => {
  if (level === 30) {
    return "default"; // warning -> default
  } else if (level === 40) {
    return "destructive"; // error -> destructive
  } else {
    return "info";
  }
};
